import { render, staticRenderFns } from "./BtnReporting.vue?vue&type=template&id=edf9765e"
import script from "./BtnReporting.vue?vue&type=script&lang=js"
export * from "./BtnReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports